<div [class]="type">
  <div class="no-data" [style.width.rem]="sizeRem.width" [style.height.rem]="sizeRem.height"></div>
</div>
